<template>
  <div>
    <transition name="fade">
      <community-selector
        v-if="showCommunitySelector"
        :closable="isCommunitySelectorClosable"
        @saved="onCommunitySelected"
        @close="showCommunitySelector = false"
      />
    </transition>
    <md-app
      md-waterfall
      md-mode="fixed"
      class='full-height'
      :class="{ 'content-blur': showCommunitySelector }"
    >
      <md-app-toolbar
        :md-elevation="1"
        class="md-primary"
      >
      <header class="main-header">
        <md-button
          class="md-icon-button"
          @click="toggleMenu"
          aria-label="Toggle navigation menu"
        >
        <!--v-if="!menuVisible"-->
          <md-icon>
            <font-awesome-icon icon="bars" />
          </md-icon>
        </md-button>
        <span class="md-title">Protopia : Just Ask</span><md-button @click="grabRequest()" class="grab-request-btn"><b>Grab Request</b></md-button>
        <div class="md-toolbar-section-end">
          <div class="community-info" v-if="communityName">
            <span class="community-name">{{ communityName }}</span>
            <md-button class="change-community-btn" @click="changeCommunity" v-if="canChangeCommunity">CHANGE COMMUNITY</md-button>
          </div>
          <md-menu md-direction="bottom-start">
            <md-button md-menu-trigger aria-label="User menu options">
              <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
            </md-button>
            <md-menu-content>
              <md-menu-item @click="logout()">LOGOUT</md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
    </header>
      </md-app-toolbar>
      <md-app-drawer
        :md-active.sync="menuVisible"
        md-persistent="full"
        class="md-scrollbar md-fixed sidebar-custom"
      >
      <nav>
        <md-list class="app-sidebar">
          <!-- Side Menu -->
          <div class='tiny-spacer'></div>
          <md-subheader class='nav-header'>Asks</md-subheader>
          <!--<md-list-item
          	@click="toggleMenu"
            class="nav-link"
            to="/asks"
          >Open
          </md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI('Active')}`"
            key="Active"
            v-if="activeCount"
          >Active ({{ activeCount }})</md-list-item>-->
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=my-request`"
          >My Requests ({{myRequestCount}})
          </md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            to="/asks/all"
          >All ({{getAllStatusCount()}})
          </md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/incomplete-request`"
            v-if="incompleteRequestCount > 0"
          >Incomplete ({{ incompleteRequestCount }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(pendingObj.status)}`"
            v-if="pendingObj.count > 0"
          >Pending ({{ pendingObj.count }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(newRequestsObj.status)}`"
            v-if="newRequestsObj.count > 0"
          >New Requests ({{ newRequestsObj.count }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI('Review')}`"
            v-if="reviewCount > 0"
          >Review ({{ reviewCount }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI('Approved')}`"
            v-if="approvedCount > 0"
          >Approved ({{ approvedCount }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(tagObj.status)}`"
            v-if="tagObj.count > 0"
          >Tag ({{ tagObj.count }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(matchObj.status)}`"
            v-if="matchObj.count > 0"
          >Match ({{ matchObj.count }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/pending-responses`"
          >
          Pending Responses ({{ pendingResponsesCount }})
          </md-list-item>
          <md-list-item
            @click="toggleMenu"
          class="nav-link"
          to="/asks/responses"
          v-if="responseStatusCount > 0"
          >New Responses ({{responseStatusCount}})</md-list-item>
          <!--<md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(status._id.status)}`"
          >Send ({{ status.count }})</md-list-item>-->
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI('Active')}`"
            v-if="activeCount > 0"
          >Active ({{ activeCount }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI('no-response')}`"
            v-if="noResponseCount > 0"
          >No Response ({{ noResponseCount }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(closedObj.status)}`"
            v-if="closedObj.count > 0"
          >Closed ({{ closedObj.count }})</md-list-item>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            :to="`/asks/search?term=${encodeURI(rejectedObj.status)}`"
            v-if="rejectedObj.count > 0"
          >Rejected ({{ rejectedObj.count }})</md-list-item>
          <md-list-item>
            <md-field md-clearable>
              <md-input
                v-model="search"
                @keyup.enter="searchAsk(search)"
                placeholder="Search Asks"
                @input="search = sanitizeInput($event)"
              >
              </md-input>
            </md-field>
          </md-list-item>
          <md-divider></md-divider>
          <template v-if="isRecruitingAccessEnabled">
            <md-subheader class='nav-header'>Recruiting</md-subheader>
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              to="/recruiting"
            >All ({{ recruitingCounts.all }})</md-list-item>
            <!-- Statuses listed alphabetically ("All" stays first as the aggregate). -->
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              :to="`/recruiting?term=active`"
              v-if="recruitingCounts.active > 0"
            >Approved ({{ recruitingCounts.active }})</md-list-item>
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              :to="`/recruiting?term=closed`"
              v-if="recruitingCounts.closed > 0"
            >Closed ({{ recruitingCounts.closed }})</md-list-item>
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              :to="`/recruiting?term=in_review`"
              v-if="recruitingCounts.in_review > 0"
            >In Review ({{ recruitingCounts.in_review }})</md-list-item>
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              :to="`/recruiting?term=incomplete`"
              v-if="recruitingCounts.incomplete > 0"
            >Incomplete ({{ recruitingCounts.incomplete }})</md-list-item>
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              :to="`/recruiting?term=quarantined`"
              v-if="recruitingCounts.quarantined > 0"
            >Quarantined ({{ recruitingCounts.quarantined }})</md-list-item>
            <md-list-item
              @click="toggleMenu"
              class="nav-link"
              :to="`/recruiting?term=rejected`"
              v-if="recruitingCounts.rejected > 0"
            >Rejected ({{ recruitingCounts.rejected }})</md-list-item>
            <md-divider></md-divider>
          </template>
          <div class="nav-header-community">
            <md-subheader class='nav-header'>Communities</md-subheader>
            <md-field class="m-left-5 nav-header-filter">
                <!-- <label>filter:</label> -->
                <md-select v-model="communityStatus" name="status" @md-selected="communityFilter" v-validate="'required'" placeholder="status" id="status">
                <md-option value="Live_Preview">Active & Preview</md-option>
                <md-option value="Live">Active</md-option>
                <md-option value="Preview">Preview</md-option>
                <md-option value="Inactive">Inactive</md-option>
              </md-select>
            </md-field>
          </div>
          <template v-for="(community,index) in filterCommunities" v-if="filterCommunities">
	          <md-list-item
	          	@click="handleCommunityClick(community)"
	            class="nav-link"
	            v-bind:key="'community'+index"
	          >{{ community.name }}</md-list-item>
          </template>
          <md-list-item
          	@click="toggleMenu"
            :to="`/communities/create`"
            class="nav-link"
          > + Create Community</md-list-item>
          <md-divider></md-divider>
          <md-subheader class='nav-header'>Members</md-subheader>
          <md-list-item
          	@click="toggleMenu"
            class="nav-link"
            to="/members/all"
          >All</md-list-item>
          <md-list-item>
            <md-field md-clearable>
              <md-input
                type="text"
                v-model="searchMember"
                @keyup.enter="searchMembers(searchMember)"
                placeholder="Search Members"
                @input="searchMember = sanitizeInput($event)"
              >
              </md-input>
            </md-field>
          </md-list-item>
          <md-divider style="margin-top: 15px;"></md-divider>
          <md-subheader class='nav-header'>General Setting</md-subheader>
          <template>
	          <md-list-item
	          	@click="toggleMenu"
	            :to="`/configuration/settings`"
	            class="nav-link"
	          >{{ displayName('Settings') }}</md-list-item>
          </template>
          <md-divider></md-divider>
          <md-subheader class='nav-header'>Email Templates</md-subheader>
          <template v-for="template in sortTemplates" v-if="Array.isArray(templates) && template.deleted !== true">
	          <md-list-item
	          	@click="toggleMenu"
	            :to="`/templates/${template._id}`"
	            class="nav-link"
	            v-bind:key="template._id"
	          >{{ template.name }}
	          </md-list-item>
          </template>
          <md-list-item
          	@click="toggleMenu"
            to="/templates/create"
            class="nav-link"
          > + Create Template</md-list-item>
          <md-subheader class='nav-header'>SMS Templates</md-subheader>
          <template v-for="smsTemplate in sortSmsTemplates" v-if="Array.isArray(smsTemplates) && smsTemplate.deleted !== true">
	          <md-list-item
	          	@click="toggleMenu"
	            :to="`/templates/sms/${smsTemplate._id}`"
	            class="nav-link"
	            v-bind:key="smsTemplate._id"
	          >{{ smsTemplate.name }}
	          </md-list-item>
          </template>
          <md-list-item
          	@click="toggleMenu"
            to="/templates/sms/create"
            class="nav-link"
          > + Create Template</md-list-item>
          <md-divider></md-divider>
          <md-subheader class='nav-header'>Configuration</md-subheader>
          <template v-for="(configuration, index) in configurations">
	          <md-list-item
	          	@click="toggleMenu"
	            :to="`/configuration/reference-${configuration}`"
	            class="nav-link"
	            v-bind:key="'configuration'+index"
	          >Reference: {{ displayName(configuration) }}</md-list-item>
          </template>
        </md-list>
        </nav>
      </md-app-drawer>
          <md-app-content>
            <vue-scroll :ops="ops" ref="vs">
                <router-view v-if="isCommunitySelected" v-on:reload="loadData" v-on:response-count="updateResponseCount" />
            </vue-scroll>
          </md-app-content>
    </md-app>
  </div>
</template>
<script>
import API from "../services/API";
import VueScroll from 'vuescroll';
import {sanitizeInput} from '../utils/sanitizer';
import CommunitySelector from './CommunitySelector';
import axios from 'axios';

const RECRUITING_STATUSES = ['in_review', 'active', 'incomplete', 'quarantined', 'closed', 'rejected'];
const CORE_API_URL = process.env.CORE_API_URL || 'http://localhost:8090';

export default {
  name: "Waterfall",
  components: {
    VueScroll,
    CommunitySelector
  },
  props: ["community_code", "auth", "authenticated"],
  data() {
    return {
      api: new API(),
	    token: '',
      communityName: localStorage.getItem('community_name') || '',
      filterCommunities: [],
      communities: [],
      templates: [],
      smsTemplates: [],
      statuses: [],
      search: "",
      searchMember: "",
      menuVisible: false,
      responseStatusCount: 0,
      activeCount: 0,
      reviewCount: 0,
      allCount: 0,
      ops: {
        rail: {
          opacity: '0.4',
          background: '#e1e1e1',
          border: '1px solid #e1e1e1',
          size: '10px'
        },
        bar: {
          background: '#747474',
          keepShow: true,
          size: '8px',
          minSize: 0.2
        },
        scrollButton: {
          enable: false,
          background: '#e1e1e1'
        },
        scrollPanel: {
          easing: 'easeInQuad',
          speed: 1000,
          scrollingX: false
        },
        vuescroll: {
          wheelScrollDuration: 0
        }
      },
      newRequestsObj: { count: 0 },
      tagObj: { count: 0 },
      matchObj: { count: 0 },
      closedObj: { count: 0 },
      rejectedObj: { count: 0 },
      pendingObj: { count: 0 },
      fullPage: true,
      approvedCount: 0,
      isCalled: false,
      configurations: ["education", "location", "organization", "roles", "skills", "filter-words", "interests", "protopia-owner", "wizard-content", "coaching-templates"],
      noResponseCount: 0,
      incompleteRequestCount: 0,
      myRequestCount: 0,
      pendingResponsesCount: 0,
      communityStatus: "Live_Preview",
      showCommunitySelector: false,
      isCommunitySelected: false,
      isRecruitingAccessEnabled: false,
      recruitingCounts: {
        all: 0,
        in_review: 0,
        active: 0,
        incomplete: 0,
        quarantined: 0,
        closed: 0,
        rejected: 0
      }
    };
  },
  created() {
    this.checkCommunityStatus();
  },
  watch: {
    $route: function() {
      if (!this.showCommunitySelector) {
        this.loadData();
        // Update community name when route changes (e.g., navigating to different community)
        this.fetchCommunityName();
      }
    }
  },
  filters: {
      capitalize: function (value) {
          if (!value) return ''
          value = value.toString()
          return value.charAt(0).toUpperCase() + value.slice(1)
      }
  },
  computed: {
  	sortTemplates: function() {
  		if (this.templates) {
  			return this.$lodash.orderBy(this.templates, function(o) { return o.name }, ['asc']);
  		}
    },
    sortSmsTemplates: function() {
  		if (this.smsTemplates) {
  			return this.$lodash.orderBy(this.smsTemplates, function(o) { return o.name }, ['asc']);
  		}
  	},
    statuses1: function() {
      var statuses = this.statuses.slice();
      var concatStatus = [];
      var insert = this.getActiveCount;
      if (statuses.length) {
        concatStatus = statuses.concat(insert);
      }
      return this.$lodash.orderBy(concatStatus, function(o) { return o.count }, ['desc']);
    },
    getActiveCount: function() {
      return [{_id: { status: 'Active' }, count: this.activeCount}, {_id: { status: 'Review' }, count: this.reivewCount}];
    },
    isCommunitySelectorClosable: function() {
        return !!localStorage.getItem('community_id');
    },
    canChangeCommunity: function() {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        if (!authUser) return false;

        const role = authUser.role ? authUser.role.toLowerCase() : '';
        if (role === 'superadmin') return true;

        return authUser.communities && authUser.communities.length > 1;
    }
  },
  methods: {
    handleCommunityClick(community) {
      this.toggleMenu();
      const currentCommunityId = localStorage.getItem('community_id');

      if (currentCommunityId === community._id) {
        if (this.$route.path !== `/communities/${community._id}`) {
            this.$router.push(`/communities/${community._id}`);
        }
      } else {
        localStorage.setItem('community_id', community._id);
        localStorage.setItem('community_name', community.name);
        // Reload to apply context switch and navigate to configuration
        // The real name will be fetched in fetchCommunityName() after reload
        window.location.href = `/communities/${community._id}`;
      }
    },
    checkCommunityStatus() {
      const savedCommunity = localStorage.getItem('community_id');
      if (!savedCommunity) {
        this.showCommunitySelector = true;
      } else {
        this.showCommunitySelector = false;
        this.isCommunitySelected = true;
        this.initializeLayout();
      }
    },
    initializeLayout() {
      this.token = localStorage.getItem('token');

      this.$root.$on('toggle-blur', (val) => {
          this.isBlurred = val;
      });

      this.$root.$on('community-selected', (id) => {
        this.isCommunitySelected = true;
        this.api = new API();
        window.location.href = '/home';
      });

      // Listen for community name changes (when saved in settings)
      this.$root.$on('community-name-changed', ({ communityId, newName }) => {
        this.updateCommunityName(communityId, newName, localStorage.getItem('community_id') === communityId);
      });

      this.fetchCommunityList();
      // Fetch real community name from tenant DB and sync to sidebar/modal
      this.fetchCommunityName();
      this.loadData();
      // Refresh sidebar counts for the active community (previously only
      // happened when the user manually toggled the drawer menu, so counts
      // stayed at 0 after a community switch until that first click).
      this.getAllData();
    },
    onCommunitySelected() {
      this.showCommunitySelector = false;
      this.isCommunitySelected = true;
      // Force navigation to /home to reset context
      window.location.href = '/home';
    },
    async fetchCommunityName() {
      const communityId = localStorage.getItem('community_id');
      if (!communityId) return;

      try {
        const response = await this.api.get(`communities/${communityId}/community-request`);
        if (response.data && response.data.name) {
          this.updateCommunityName(communityId, response.data.name, true);
        }
      } catch (e) {
        console.error("Failed to fetch community name", e);
        if (!this.communityName) {
          const current = this.communities.find(c => c._id === communityId);
          if (current) this.communityName = current.name;
        }
      }
    },

    // Update name in both communities and filterCommunities arrays
    updateNameInArrays(communityId, newName) {
      const updateArray = (arr) => {
        const idx = arr.findIndex(c => c._id === communityId);
        if (idx !== -1 && arr[idx].name !== newName) {
          this.$set(arr, idx, { ...arr[idx], name: newName });
        }
      };
      updateArray(this.communities);
      updateArray(this.filterCommunities);
    },

    // function to update community name everywhere: header, sidebar, cache, and notify modal
    updateCommunityName(communityId, realName, updateHeader = false) {
      if (updateHeader || localStorage.getItem('community_id') === communityId) {
        this.communityName = realName;
        localStorage.setItem('community_name', realName);
      }

      if (!Array.isArray(this.communities)) return;

      const index = this.communities.findIndex(c => c._id === communityId);
      if (index !== -1 && this.communities[index].name !== realName) {
        this.updateNameInArrays(communityId, realName);

        const cache = JSON.parse(localStorage.getItem('community_names_cache') || '{}');
        cache[communityId] = realName;
        localStorage.setItem('community_names_cache', JSON.stringify(cache));

        //Updated modal
        this.$root.$emit('community-list-updated', [...this.communities]);
      }
    },

    // Apply cached names when loading communities list from /tenants
    applyCachedNames() {
      try {
        const cache = JSON.parse(localStorage.getItem('community_names_cache') || '{}');
        Object.keys(cache).forEach(communityId => {
          const c = this.communities.find(comm => comm._id === communityId);
          if (c && cache[communityId] !== c.name) {
            this.updateNameInArrays(communityId, cache[communityId]);
          }
        });
      } catch (e) {
        console.error('Error applying cached names:', e);
      }
    },
    changeCommunity() {
      this.fetchCommunityName();
      this.showCommunitySelector = true;
      this.$root.$emit('community-list-updated', [...this.communities]);
    },
    loadData: async function() {
      if (this.showCommunitySelector) return;
      const communityId = localStorage.getItem('community_id');
      if (communityId) {
        this.communityName = null;
        await this.fetchCommunityName();
      }

        // var authUserEail = JSON.parse(localStorage.authUser).emails[0].split('@');
        // if (JSON.parse(localStorage.authUser).emails[0] === 'max@protopia.co' || authUserEail[1] === "websoptimization.com") {
        //     this.subMenuVisible = true;
        // }
        // if (JSON.parse(localStorage.authUser).emails[0])
      // this.api.get(`asks/response-status`).then(statuses => {
      //   this.responseStatusCount = 0;
      //   if (Array.isArray(statuses.data)) {
      //     statuses.data.map(status => {
      //       status.gives.map(give => {
      //         if (give.helpaction === 'yes' && give.responseState && give.responseState.currentState === 'In Review' && ['Insight', 'Share Advice'].includes(give.action)) {
      //           this.responseStatusCount += 1;
      //         }
      //       });
      //     });
      //   }
      // });
    },
    displayName: function(value) {
    const displayNames = {
        'filter-words': 'Filter Words',
        'protopia-owner': 'Protopia Owner',
        'wizard-content': 'Wizard Content',
        'coaching-templates': 'Coaching Templates'
    };
    if (displayNames[value]) {
        return displayNames[value];
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
    },
    sanitizeInput: function(value) {
        return sanitizeInput(value);
    },
    searchAsk: function(search) {
      if (search.length > 0) {
        this.$router.push(`/asks/search?s=${search}`);
      } else {
        this.$router.push(`/asks/all`);
      }
    },
    searchMembers: function(searchMember) {
      if (searchMember.length > 0) {
        this.$router.push(`/members/search?term=${searchMember}`);
      } else {
        this.$router.push(`/members/all`);
      }
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      this.getAllData();
      if (this.menuVisible) {
        this.getAllSmsTemplate();
        this.getAllTemplate();
      }
    },
    logout() {
      this.auth.logout();
    },
    async allStatues(community) {
        await this.api.get(`asks/statuses?community=${community}`).then(async statuses => {
          if (Array.isArray(statuses.data)) {
            this.statuses = statuses.data.sort((a, b) => {
              return a._id.status > b._id.status ? 1 : -1;
            });
            var statusesLst = this.statuses.slice();
            var concatStatus = [];
            var insert = this.getActiveCount;
            if (statusesLst.length) {
              concatStatus = statusesLst.concat(insert);
            }
            concatStatus.map(status => {
              if (status._id.status === '(0) New') {
                this.newRequestsObj.count = status.count || 0;
                this.newRequestsObj.status = status._id.status;
              } else if (status._id.status === '(1) Tagged') {
                this.tagObj.count = status.count || 0;
                this.tagObj.status = status._id.status;
              } else if (status._id.status === '(2) Matched') {
                this.matchObj.count = status.count || 0;
                this.matchObj.status = status._id.status;
              } else if (status._id.status === '(7) Closed') {
                this.closedObj.count = status.count || 0
                this.closedObj.status = status._id.status
              } else if (status._id.status === '(8) Rejected') {
                this.rejectedObj.count = status.count || 0;
                this.rejectedObj.status = status._id.status;
              } else if (status._id.status === 'Pending') {
                this.pendingObj.count = status.count || 0;
                this.pendingObj.status = status._id.status;
              }
            });
            if (statuses.data.length) {
              this.activeCount = this.reviewCount = this.approvedCount = 0;
              await statuses.data.map(status => {
                if (['(3) Dispatched', '(5) Responded', '(6) Feedback requested', '(6) Feedback added'].includes(status._id.status)) {
                  this.activeCount += status.count;
                } else if (status._id.status === 'In Review') {
                  this.reviewCount += status.count;
                } else if (status._id.status === 'Reviewed') {
                  this.approvedCount += status.count;
                }
              });
            }
          }
        });
    },
    updateResponseCount(community) {
        this.api.get(`asks/response-status?community=${community}`).then(statuses => {
            this.responseStatusCount = 0;
            if (typeof statuses.data != 'undefined') {
              this.responseStatusCount = statuses.data;
            }
            // if (Array.isArray(statuses.data)) {
            //     statuses.data.map(status => {
            //         if (status.status !== '(7) Closed' && status.status !== '(8) Rejected') {
            //             status.gives.map(give => {
            //                 if (give.helpaction === 'yes' && give.responseState && ['In Review', 'Pending'].includes(give.responseState.currentState) && ['Insight', 'Share Advice'].includes(give.action)) {
            //                     this.responseStatusCount += 1;
            //                 }
            //             });
            //         }
            //     });
            // }
        });
    },
    async fetchPendingResponsesCount(community) {
    try {
      const response = await this.api.get(`asks/pending-responses?community=${community}`);
      if (response && response.data) {
        this.pendingResponsesCount = response.data.count || 0;
      }
    } catch (error) {
      console.error('Error fetching pending responses count:', error);
        }
    },
    noResponse(community) {
        this.api.get(`asks/no-response-count?community=${community}`).then(count => {
            this.noResponseCount = count.data;
        });
    },
    incompleteRequestCountFunc(community) {
        this.api.get(`asks/incomplete-request-count?community=${community}`).then(count => {
            this.incompleteRequestCount = count.data;
        });
    },
    async getMyRequestsCount(community) {
      this.api.get(`asks/my-request-count?community=${community}`).then(count => {
        this.myRequestCount = count.data > 0 ? count.data : 0;
      });
    },
    getAllStatusCount: function () {
      if (!this.statuses.length) return 0;
      return this.statuses.reduce((result, status) => {
        return result + (status.count || 0);
      }, 0);
    },
    getAllTemplate: async function () {
      await this.api.get(`templates`).then(async templates => {
        this.templates = templates.data;
        if (!this.templates || this.templates.length === 0) {
          await this.api.get(`templates/create-defaults`).then(async res => {
            await this.api.get(`templates`).then(templates => {
              this.templates = templates.data;
            });
          });
        }
      });
    },
    getAllSmsTemplate: async function () {
      this.api.get(`sms-templates`).then(async smsTemplates => {
        this.smsTemplates = smsTemplates.data;
      });
    },
    getAllCommunity: async function () {
      if (this.communities.length === 0) {
          this.fetchCommunityList();
      }
    },
    communityFilter: async function () {
      // Re-apply filter on existing communities data instead of fetching again
      if (this.communities.length > 0) {
        if (this.communityStatus == 'Live_Preview') {
          this.filterCommunities = this.communities.filter(c => c.settings.siteStatus === 'Live' || c.settings.siteStatus === 'Preview');
        } else {
          this.filterCommunities = this.communities.filter(c => c.settings.siteStatus === this.communityStatus);
        }
      } else {
          // If no communities loaded yet, try to fetch
          this.fetchCommunityList();
      }
    },
    getAllData: function () {
      const community = localStorage.getItem('community_id');
      this.allStatues(community);
      this.updateResponseCount(community);
      this.fetchPendingResponsesCount(community);
      this.noResponse(community);
      this.incompleteRequestCountFunc(community);
      this.getMyRequestsCount(community);
      this.refreshRecruitingData(community);
      this.getAllCommunity();
    },
    // Recruiting sidebar: gate by community.recruiting.enabled + compute
    // per-status counts client-side (0 changes to core-api).
    async refreshRecruitingData(community) {
      this.isRecruitingAccessEnabled = false;
      this.resetRecruitingCounts();
      if (!community || community === 'all') return;

      let enabled = false;
      try {
        const token = localStorage.getItem('auth0_token');
        const { data } = await axios.get(
          `${CORE_API_URL}/api/recruiting/${community}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );
        enabled = !!(data && data.enabled === true);
      } catch (e) {
        enabled = false;
      }
      this.isRecruitingAccessEnabled = enabled;
      if (!enabled) return;

      try {
        const token = localStorage.getItem('auth0_token');
        // core-api /api/opportunities expects the community NAME (not _id),
        // matching how the dashboard talks to the same endpoint.
        const communityName = localStorage.getItem('community_name') || '';
        const baseParams = { limit: 500, offset: 0 };
        const { data } = await axios.get(
          `${CORE_API_URL}/api/opportunities`,
          {
            params: communityName
              ? { ...baseParams, community: communityName }
              : baseParams,
            headers: token ? { Authorization: `Bearer ${token}` } : {}
          }
        );
        const list = Array.isArray(data) ? data : (data && data.data) || [];
        const counts = { all: list.length };
        RECRUITING_STATUSES.forEach(s => { counts[s] = 0; });
        list.forEach(o => {
          const s = o && o.status;
          if (s && counts[s] !== undefined) counts[s] += 1;
        });
        this.recruitingCounts = counts;
      } catch (e) {
        this.resetRecruitingCounts();
      }
    },
    resetRecruitingCounts() {
      this.recruitingCounts = {
        all: 0, in_review: 0, active: 0,
        incomplete: 0, quarantined: 0, closed: 0, rejected: 0
      };
    },
    async grabRequest() {
      await this.api.get('asks/grab-request', { headers: { 'x-access-token': this.token } }).then(response => {
        if (response && response.data) {
          if (response.data.sucess == false && response.data.message) {
            this.$toast.error(response.data.message);
          }
          if (response.data.sucess == true && response.data.redirectAskId) {
            // if current url has ask id then refresh the page else redirect to that ask
            if (this.$route.path.includes(response.data.redirectAskId)) {
              this.$router.go();
            } else {
              this.$router.push(`/asks/${response.data.redirectAskId}/request`);
            }
          }
        }
      });
    },
    processCommunitiesList(allCommunities) {
      const authUser = JSON.parse(localStorage.getItem('authUser'));
      if (!authUser) {
        this.communities = [];
        this.filterCommunities = [];
        return;
      }

      const role = (authUser.role && authUser.role.toLowerCase()) || '';
      this.communities = role === 'superadmin'
        ? allCommunities
        : allCommunities.filter(c => authUser.communities && authUser.communities.includes(c._id));

      this.applyCachedNames();
      this.filterCommunities = [...this.communities];

      // Set initial community name from list (fallback - real name fetched in fetchCommunityName)
      const currentCommunityId = localStorage.getItem('community_id');
      if (currentCommunityId && !this.communityName) {
        const current = this.communities.find(c => c._id === currentCommunityId);
        if (current) {
          this.communityName = current.name;
          localStorage.setItem('community_name', current.name);
        }
      }
    },

    async fetchCommunityList() {
      const api = new API();
      if (api.headers && api.headers.headers) delete api.headers.headers['x-tenant-id'];

      try {
        const response = await api.get('tenants');
        if (response.data && response.data.data) {
          const allCommunities = response.data.data
            .map(t => ({ _id: t.communityId, name: t.communityName, settings: { siteStatus: 'Live' } }))
            .sort((a, b) => a.name.localeCompare(b.name));
          this.processCommunitiesList(allCommunities);
        }
      } catch (error) {
        console.error("Error fetching community list:", error);
        // Fallback to old endpoint
        try {
          const fallbackApi = new API();
          if (fallbackApi.headers && fallbackApi.headers.headers) delete fallbackApi.headers.headers['x-tenant-id'];
          const response = await fallbackApi.get('communities/all');
          if (response.data) this.processCommunitiesList(response.data);
        } catch (e) {
          console.error("Fallback fetch failed", e);
        }
      }
    }
  }
};
</script>

<style scoped>
.community-info {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.community-name {
  font-weight: bold;
  margin-right: 15px;
  color: white;
  font-size: 16px;
}

.change-community-btn {
  border: 1px solid white;
  color: white !important;
  height: 30px;
  line-height: 30px;
  min-height: 30px;
  font-size: 12px;
}

.content-blur {
  filter: blur(5px);
  pointer-events: none;
  user-select: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue